import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/plugins/axios";
import "@/plugins/sweetAlert";
import "@/plugins/kendo";
import "@/plugins/bootstrap";
import "@/plugins/vue-toasted";
import "@/plugins/filters";
import "@/plugins/jquery.notyfy";

import "./assets/main.scss";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
